<template>
  <!-- 仪器详情（固定式仪器） -->
  <div class="equipModel">
    <div class="left-div">
      <div class="head-portrait">
        <div class="imgs-container">
          <img :src="particular.photoLink" alt />
        </div>
      </div>
      <div class="text-conten">
        <div class="yq_name">
          <span>所在仪器柜：</span>
          <span>建科院1号智能柜</span>
        </div>
        <div class="slogan">
          <span>电源控制器：</span>
         {{ particular.address|| particular.boxIndex }}
        </div>
        <template v-if="particular.states == 0">
          <div class="state state1">
            <i class="yuandian"></i>
            <span>正常</span>
          </div>
        </template>
        <template v-if="particular.states == 1">
          <div class="state state3">
            <i class="yuandian"></i>
            <span>降级</span>
          </div>
        </template>
        <template v-if="particular.states == 2">
          <div class="state state2">
            <i class="yuandian"></i>
            <span>停用</span>
          </div>
        </template>
        <template v-if="particular.states == 3">
          <div class="state state2">
            <i class="yuandian"></i>
            <span>需维修</span>
          </div>
        </template>
        <template v-if="particular.states == 4">
          <div class="state state3">
            <i class="yuandian"></i>
            <span>需检定</span>
          </div>
        </template>
        <template v-if="particular.states == 5">
          <div class="state state3">
            <i class="yuandian"></i>
            <span>需保养</span>
          </div>
        </template>
        <template v-if="particular.states == 6">
          <div class="state state3">
            <i class="yuandian"></i>
            <span>报废</span>
          </div>
        </template>
      </div>
      <div class="qcode">
        <div class="imgs-container">
          <img :src="particular.qrcodeUrl" alt />
        </div>
      </div>
    </div>
    <div class="middle-div">
      <div class="row-item yq-name">{{ particular.instrumentName }}</div>
      <div class="row-item">
        <div class="left_item">
          <span>仪器编号：</span>
          {{ particular.serialNumber }}
        </div>
        <div class="rigth-item">
          <span>价钱：</span>
          {{ particular.prize?particular.prize:"暂无" }}
        </div>
      </div>
      <div class="row-item">
        <div class="left_item">
          <span>型号：</span>
          {{ particular.pattern }}
        </div>
        <div class="rigth-item">
          <span>启用日期：</span>
          {{ particular.startUpTime?particular.startUpTime.split(' ')[0]:"" }}
        </div>
      </div>
      <div class="row-item">
        <div class="left_item">
          <span>出厂编号：</span>
          {{ particular.factoryNumber }}
        </div>
        <div class="rigth-item">
          <span>出厂日期：</span>
          {{ particular.produceTime }}
        </div>
      </div>
      <div class="row-item">
        <span>生产厂商：</span>
        {{ particular.factoryName }}
      </div>
      <div class="row-item">
        <div class="left_item">
          <span>充电型设备：</span>
          <i :class="[
              'iconfont',
              particular.isCharger == 0
                ? 'icon-close-square'
                : 'icon-gouxuanfangkuang',
            ]"></i>
        </div>
        <div class="rigth_item">
          <span>是否需要充电：</span>
          <i :class="[
              'iconfont',
              particular.isNeedPower == 0
                ? 'icon-close-square'
                : 'icon-gouxuanfangkuang',
            ]"></i>
        </div>
      </div>
      <div class="attachment">
        <h3>附件：</h3>
        <div class="attachment-conter">
          <template v-for="(item, index) in particular.files">
            <div :class="['attachment-item', index == 8 ? 'widts' : '']" :key="index" @click="toDownload(item)">
              <span class="left">
                <i class="iconfont icon-word" style="margin-right: 4px"></i>
                <span class="fileName">{{ item.fileName }}</span>
                <span class="typeName"> {{ item.typeName }}</span>
              </span>
              <i class="iconfont icon-xiazai-" style="margin-right: 4px"></i>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="right-div">
      <div class="btn-list">
        <div class="my-buttom" @click="delelItem()">删除</div>
      </div>
      <div class="row-item">
        <span>检定/校准机构：</span>
        {{ particular.calibrationMechanism }}
      </div>
      <div class="row-item">
        <div class="left_item">
          <span>检定/校准周期：</span>
          {{ particular.validityPeriod }}
        </div>
        <div class="rigth_item">
          <span>保养周期：</span>
          {{ particular.maintenancePeriod }}
        </div>
      </div>
      <div class="row-item box-item">
        <div class="left_item">
          <div class="left_item_top">
            <span>不确定度/准确度</span>
          </div>
          <div class="left_item_botm">
            <div style="width: 50%">
              <span>出厂：{{ particular.accuracy }}</span>
            </div>
            <div style="width: 50%">
              <span>检定：{{ particular.currentAccuracy }}</span>
            </div>
          </div>
        </div>
        <div class="rigth_item">
          <div class="left_item_top">
            <span>精度（mm）</span>
          </div>
          <div class="left_item_botm">
            <div style="width: 50%">
              <span>出厂：{{ particular.precision }}</span>
            </div>
            <div style="width: 50%">
              <span>检定：{{ particular.currentPrecision }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row-item">
        <span>量程：</span>
        {{ particular.range }}
      </div>
      <div class="row-item">
        <span>上次检定时间：</span>
        {{ particular.lastCalibrationTime }}
      </div>
      <div class="row-item">
        <span>上次保养时间：</span>
        {{ particular.lastMaintenanceTime }}
      </div>
      <div class="row-item">
        <span>检定/校准有效期：</span>
        {{ particular.validityEffectiveTime }}
      </div>
      <div class="row-item">
        <span>保养有效期：</span>
        {{ particular.maintenanceEffectiveTime }}
      </div>
      <div class="requirements">
        <h3>检定要求：</h3>
        <div class="requirements-text bar">
          <span>{{ particular.requirements }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { FileUrl } from "@/api/depotApi";
export default {
  props: {
    message: Object,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(["depot"]),
    particular() {
      return this.depot.redactInstrument;
    },
    showBg() {
      if (this.particular && this.particular.files) {
        let length = this.particular.files.length - 1;
        return length;
      } else {
        return "无";
      }
    },
  },
  methods: {
    delelItem() {
      this.$emit("deleteItem", this.particular.id);
    },
    toDownload(data) {
      FileUrl({ objectName: data.filePath }).then((res) => {
        if (res.code == 200) {
          window.open(res.data);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.equipModel {
  width: 100%;
  color: #74c8fe;
  display: flex;

  .left-div,
  .middle-div,
  .right-div {
    float: left;
    width: 31%;
    min-width: 333px;
    .btn-list {
      text-align: right;
      margin: 13px 20px;
    }
  }
  .left-div {
    margin-right: 2%;
    position: relative;
    .head-portrait {
      .imgs-container {
        height: 200px;
        width: 200px;
        margin: auto;
        margin-top: 30px;
        box-shadow: 0 0 15px #0abde6 inset;
        border-radius: 50%;
        -o-object-fit: cover;
        object-fit: cover;
        position: relative;
        img {
          position: absolute;
          width: 120px;
          height: 120px;
          left: 50%;
          top: 50%;
          -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
        }
      }
    }
    .text-conten {
      text-align: center;
      div {
        margin: 10px 0;
      }
      .yq_name {
        font-size: 20px;
      }
      .slogan {
        font-size: 18px;
      }
      .state {
        font-size: 16px;
      }
    }
    .qcode {
      position: absolute;
      left: 50%;
      top: 70%;
      -webkit-transform: translate(-50%, -50%);
      .imgs-container {
        width: 350px;
        height: 350px;
        margin: auto;
        background: url("~@/assets/images/qcode.png");
        background-repeat: no-repeat;
        background-position-x: center;
        background-position-y: center;
        background-size: 150%;
        position: relative;
        img {
          position: absolute;
          width: 150px;
          height: 150px;
          left: 52%;
          top: 62%;
          -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
        }
      }
    }
  }
  .middle-div {
    margin-right: 2%;
    float: left;
    height: 600px;
    .row-item {
      width: 100%;
      overflow: hidden;
      margin: 16px 0px;
      display: flex;
      .left_item {
        width: 50%;
        display: inline-block;
      }
      .rigth_item {
        width: 50%;
        display: inline-block;
        .parameter {
          width: 50%;
          text-align: center;
          float: left;
          margin-bottom: 14px;
        }
      }
    }
    .attachment {
      .attachment-conter {
        height: 300px;
        border-radius: 4px;
        padding: 6px;
        box-sizing: border-box;
        overflow-y: auto;
      }
      .attachment-conter::-webkit-scrollbar {
        width: 4px;
      }
      .attachment-conter::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: rgba(0, 0, 0, 0.2);
      }
      .attachment-conter::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 0;
        background: rgba(0, 0, 0, 0.1);
      }
      .attachment-item {
        width: 99%;
        height: 35px;
        line-height: 35px;
        margin-right: 1%;
        margin-bottom: 10px;
        padding-left: 14px;
        float: left;
        box-sizing: border-box;
        border: 2px solid #018be9;
        border-radius: 4px;
        cursor: pointer;
        background: linear-gradient(
          180deg,
          rgba(49, 210, 255, 0.52),
          rgba(0, 57, 142, 0.52)
        );
        display: flex;
        justify-content: space-between;
        .left {
          display: inline-block;
          width: 98%;
          white-space: nowrap;
          display: flex;
          align-items: center;
          .fileName {
            width: 275px;
            min-width: 180px;
            overflow: hidden; //超出的文本隐藏
            text-overflow: ellipsis; //溢出用省略号显示
            white-space: nowrap;
            display: inline-block;
          }
          .typeName {
            display: inline-block;
            width: 115px;
            min-width: 100px;
            overflow: hidden; //超出的文本隐藏
            text-overflow: ellipsis; //溢出用省略号显示
            white-space: nowrap;
          }
        }
        color: #74c8fe;
      }
      .widts {
        width: 99%;
      }
    }
    .yq-name {
      font-size: 20px;
    }
  }
  .right-div {
    float: left;
    height: 600px;
    .row-item {
      margin: 16px 0px;
      display: flex;
      .left_item,
      .rigth_item {
        width: 50%;
      }
      .left_item_top {
        text-align: center;
        height: 30px;
        line-height: 30px;
        border-bottom: 1px solid #74c8fe;
      }
      .left_item_botm {
        height: 30px;
        line-height: 30px;
        display: flex;
      }
    }
    .box-item {
      .left_item {
        width: 40%;
        height: 60px;
        padding: 6px 12px;
        box-shadow: 0 0 15px #0071f1 inset;
        border-radius: 6px;
        margin-right: 10px;
      }
      .rigth_item {
        width: 40%;
        height: 60px;
        padding: 6px 12px;
        box-shadow: 0 0 15px #0071f1 inset;
        border-radius: 6px;
        margin-right: 10px;
      }
    }
    .requirements {
      h3 {
        margin-bottom: 10px;
      }
      .requirements-text {
        height: 145px;
        overflow-y: auto;
        border: 1px solid #009cff;
        background: #074785;
        border-radius: 4px;
        padding: 6px;
        box-sizing: border-box;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Instrumentmanagemen/components/equipModel.vue